export default __webpack_public_path__ + "static/media/6.fc816591.jpeg";